export default "skymp5-front/660b04543151317bbe7b0022c3d85fdd.png";